module.exports = __webpack_public_path__ + "img/live-review-tit.0b847a92.png";